import React from "react";
import { FundingRateDetails } from "./FundingRateDetails";
import { PositionsDisplay } from "./PositionsDisplay";

export interface Message {
  id: number;
  timestamp: number;
  channel: string;
  data: any;
  type: "success" | "error" | "info" | "warning" | "debug";
  step?: string;
}

interface MessageItemProps {
  message: Message;
}

export const MessageItem: React.FC<MessageItemProps> = ({ message }) => {
  const { channel, data, type, step, timestamp } = message;

  // Check if this is a funding_rate message with formatted display
  const isFundingRate =
    channel === "funding_rate" && typeof data === "object" && data !== null;

  // Check if this is a user_updates message with positions
  const isUserUpdatesWithPositions =
    channel === "user_updates" &&
    typeof data === "object" &&
    data !== null &&
    Array.isArray(data.positions) &&
    data.positions.length > 0;

  // Determine if we should show the formatted view (and hide the JSON body)
  const showFormattedView = isFundingRate || isUserUpdatesWithPositions;

  return (
    <div className={`message-item ${type}`}>
      <div className="message-header">
        <div className="message-content">
          <div className="message-title">
            <span>[{channel}]</span>
            {step && <span className="message-step">({step})</span>}
            <span>{new Date(timestamp).toLocaleTimeString()}</span>
          </div>

          {/* Formatted funding rate display */}
          {isFundingRate && <FundingRateDetails data={data} />}

          {/* Formatted positions display */}
          {isUserUpdatesWithPositions && (
            <PositionsDisplay positions={data.positions} />
          )}

          {/* Message body - hide if formatted view is shown */}
          {!showFormattedView && (
            <div className="message-body">
              {typeof data === "string"
                ? data
                : JSON.stringify(data).substring(0, 20)}
              {"..."}
            </div>
          )}

          {/* Raw data view (always available for objects) */}
          {typeof data !== "string" && (
            <details>
              <summary className="raw-data-summary">View Raw Data</summary>
              <pre className="raw-data-pre">
                {JSON.stringify(data, null, 2)}
              </pre>
            </details>
          )}
        </div>
      </div>
    </div>
  );
};
